var _g, _rect, _g2, _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagManagementNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 168,
    viewBox: "0 0 246 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2190_155515)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 38,
    width: 150,
    height: 50,
    rx: 25,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 42.5,
    width: 141,
    height: 41,
    rx: 20.5,
    fill: "white",
    stroke: "url(#paint0_linear_2190_155515)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_2190_155515)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 63,
    r: 14,
    stroke: "url(#paint1_linear_2190_155515)",
    strokeWidth: 1.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.983,
    cy: 70.5239,
    r: 0.93018,
    fill: "url(#paint2_linear_2190_155515)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.863 55C125.472 55 127.608 57.0623 127.72 59.6399L127.726 59.8542C127.726 61.736 126.645 63.4359 124.954 64.2398L124.771 64.3225C124.034 64.6366 123.542 65.3436 123.487 66.1505L123.482 66.3029V67.7388C123.482 68.0803 123.205 68.3571 122.863 68.3571C122.549 68.3571 122.29 68.1245 122.249 67.8227L122.243 67.7388V66.3029C122.243 64.9968 122.976 63.8203 124.125 63.2579L124.284 63.1851C125.613 62.6188 126.474 61.3268 126.487 59.8872L126.486 59.8543C126.486 57.8596 124.861 56.2368 122.863 56.2368C120.864 56.2368 119.239 57.8596 119.239 59.8543C119.239 60.1959 118.962 60.4727 118.619 60.4727C118.277 60.4727 118 60.1959 118 59.8543C118 57.1776 120.181 55 122.863 55Z",
    fill: "url(#paint3_linear_2190_155515)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2190_155515",
    x: 0,
    y: 8,
    width: 246,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2190_155515"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 18,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.74902 0 0 0 0 0.976471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2190_155515",
    result: "effect2_dropShadow_2190_155515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2190_155515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2190_155515",
    x: 60.25,
    y: 0.25,
    width: 125.5,
    height: 125.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -18,
    dy: -18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2190_155515"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 18,
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.74902 0 0 0 0 0.976471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2190_155515",
    result: "effect2_dropShadow_2190_155515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2190_155515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2190_155515",
    x1: 137.316,
    y1: 124.997,
    x2: 139.004,
    y2: 33.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E404DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2190_155515",
    x1: 125.823,
    y1: 104.332,
    x2: 129.612,
    y2: 43.5464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E404DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2190_155515",
    x1: 122.701,
    y1: 72.6293,
    x2: 131.059,
    y2: 61.1034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E404DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2190_155515",
    x1: 115.649,
    y1: 76.7433,
    x2: 136.623,
    y2: 47.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#043FE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000CD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagManagementNotFound);
export default __webpack_public_path__ + "static/media/tag-management-not-found.dcb55276.svg";
export { ForwardRef as ReactComponent };